module.exports = __webpack_public_path__ + "img/w1.ba22442e.png";